import { IVerbaScholaExerciseImageQualityReview } from '../api/VerbaScholaApi';

export const CURRENT_EXERCISE_IMAGE_REVIEW_VERSION = 'image-only-contrast-v1';

export function isEarlierImagePass(review?: IVerbaScholaExerciseImageQualityReview | null): boolean {
    return Boolean(review && (review.status === 'passed' || review.accepted === true)
        && review.review_version !== CURRENT_EXERCISE_IMAGE_REVIEW_VERSION);
}
